import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import M_NavBar from "../../../Molecules/Common/Navigations/M_NavBar";
import M_MainDrawer from "../../../Molecules/Common/Navigations/M_MainDrawer";
import M_GlobalSearch from "../../../Molecules/Common/Navigations/M_GlobalSearch/M_GlobalSearch";
import { isSearchHotkey } from "../../../Molecules/Common/Navigations/M_GlobalSearch/M_GlobalSearch.helper";
import { connect, useDispatch, useSelector } from "react-redux";
import { portfolioapproval } from "../../../Molecules/Common/PageHeaders/Toolbar/M_ToolbarFilterhelper";
import { resetFiltersValue } from "../../../../../store/actions/manageFilterValueAction";

const O_Navigation = (props) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [iconClicked, setIconClicked] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const showSearch = useSelector((state) => state.showSearch);
  const dispatch = useDispatch();
  const [currentPathName] = useState(
    localStorage.getItem(portfolioapproval.CURRENTPATHNAME)
      ? localStorage.getItem(portfolioapproval.CURRENTPATHNAME)
      : ""
  );

  const handleDrawer = (isIconClicked = false) => {
    setOpenDrawer(!openDrawer);
    setIconClicked(false);
    if (isIconClicked) {
      setIconClicked(true);
    }
  };

  useEffect(() => {
    var pathname = window.location.pathname;
    var parts = pathname.split("/");
    if (parts.length > 1) {
      if (currentPathName !== parts[1] && currentPathName !== "") {
        dispatch(resetFiltersValue());
      } else localStorage.removeItem("chartStorageKeys");
      localStorage.setItem(portfolioapproval.CURRENTPATHNAME, parts[1]);
    }
  }, [currentPathName]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (isSearchHotkey(event)) {
        if (showSearch === false) {
          return;
        }
        event.preventDefault();
        setSearchOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [showSearch]);

  return (
    <React.Fragment>
      <M_NavBar
        {...props}
        handleDrawer={(e) => handleDrawer(e)}
        onOpenSearch={() => setSearchOpen(true)}
      />

      <M_MainDrawer
        openDrawer={openDrawer}
        user={props.user}
        handleDrawer={(e) => handleDrawer(e)}
        iconClicked={iconClicked}
      />

      {showSearch !== false && (
        <M_GlobalSearch
          open={searchOpen}
          onClose={() => setSearchOpen(false)}
        />
      )}
    </React.Fragment>
  );
};

O_Navigation.propTypes = {
  user: PropTypes.object,
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(O_Navigation);
